'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';
import ErrorContent from './(error-pages)/error-content';
export default function GlobalError({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);
  return <html lang='fa' dir='rtl' className='iransans-x-numbers font-iran-sans' data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
            <body>
                <ErrorContent statusCode='default' data-sentry-element="ErrorContent" data-sentry-source-file="global-error.tsx" />
            </body>
        </html>;
}